import { useEffect, useState } from 'react'
import Button from '@components/atoms/button'
import CommonCarousel from '@components/common/carousel'
import TestimonialCard from '@components/summer-camp/testimonial-card'
import { ResponsiveType } from 'react-multi-carousel'

const TEACHERS = [
  {
    name: 'Moksha Sanghavi',
    role: 'Senior Teacher Manager',
    image: '/images/teacher-lp/teachers/moksha.png',
    quote:
      'Codingal has helped me grow not just as a teacher, but as a lifelong learner — constantly improving my skills and discovering new ways to inspire the next generation of coders.',
  },
  {
    name: 'Amit Dhanwani',
    role: 'Senior Teacher Manager',
    image: '/images/teacher-lp/teachers/amit.png',
    quote:
      'My journey at Codingal has been about guiding students to transform curiosity into creativity and creativity into innovation.',
  },
  {
    name: 'Aditya Singh',
    role: 'Teacher Manager',
    image: '/images/teacher-lp/teachers/aditya.png',
    quote:
      'What I love most about Codingal is the positive impact I get to make every day. From teacher to Teacher Manager, it has truly shaped my growth and confidence.',
  },
  {
    name: 'Paras Bajaj',
    role: 'Coding Coach',
    image: '/images/teacher-lp/teachers/paras.png',
    quote:
      'What I value most at Codingal is the supportive community and strong bond with students and parents. The flexible work culture and practical curriculum have made this journey truly rewarding.',
  },
  {
    name: 'Nisa Rasheed',
    role: 'Coding Instructor',
    image: '/images/teacher-lp/teachers/nisa.png',
    quote:
      "I share a heartfelt bond with my students, and their achievements make me truly proud. I'm also impressed by Codingal's expert-designed and professionally built curriculum.",
  },
  {
    name: 'Laiba Rahat',
    role: 'Sr. Coding Instructor',
    image: '/images/teacher-lp/teachers/laiba.png',
    quote:
      "I love seeing my students grow in confidence and celebrate their achievements. Codingal's supportive community, flexibility, and structured curriculum make teaching truly rewarding.",
  },
]

const RESPONSIVE: ResponsiveType = {
  desktop: { breakpoint: { max: 4000, min: 1024 }, items: 3 },
  tablet: { breakpoint: { max: 1023, min: 640 }, items: 2 },
  mobile: { breakpoint: { max: 639, min: 0 }, items: 1 },
}

const getBreakpointItems = (width: number): number => {
  if (width >= 1024) return RESPONSIVE.desktop.items as number
  if (width >= 640) return RESPONSIVE.tablet.items as number
  return RESPONSIVE.mobile.items as number
}

type Props = {
  handleBecomeTeacher: () => void
}

const TeacherStories = ({ handleBecomeTeacher }: Props) => {
  const [showDots, setShowDots] = useState(false)

  useEffect(() => {
    const update = () =>
      setShowDots(TEACHERS.length > getBreakpointItems(window.innerWidth))
    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  return (
    <div className="px-5 py-12 lg:py-16 bg-white">
      <div className="container mx-auto">
        <h2 className="max-w-4xl mx-auto pb-3 text-2xl text-center text-grey lg:text-4xl font-600">
          Real teachers. Real impact.
        </h2>
        <p className="text-lg text-grey mx-auto leading-tight text-center">
          Short stories and moments from teachers across tracks and time zones.
        </p>

        <div className="mt-10">
          <CommonCarousel responsive={RESPONSIVE} showDots={showDots}>
            {TEACHERS.map((teacher) => (
              <div key={teacher.name} className="px-2 h-full">
                <TestimonialCard
                  name={teacher.name}
                  subHeading={teacher.role}
                  image={teacher.image}
                  rating="5"
                  content={teacher.quote}
                  size={81}
                />
              </div>
            ))}
          </CommonCarousel>
        </div>

        <div className="flex justify-center mt-10">
          <Button
            variant="solid"
            intent="primary"
            size="lg"
            onClick={handleBecomeTeacher}
            className="w-full sm:w-auto"
          >
            Become a teacher
          </Button>
        </div>
      </div>
    </div>
  )
}

export default TeacherStories
